















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'BaseSlider',
})
export default class BaseSlider extends Vue {
  @Prop([
    String,
    Number,
  ])
  private value!: string | number;

  @Prop({
    type: Number,
    default: 0
  })
  private minValue!: number;

  @Prop({
    type: Number,
    default: 5
  })
  private maxValue!: number;

  @Prop({
    type: Number,
    default: 1
  })
  private steep!: number;

  @Prop({
    type: Number,
    default: 1
  })
  private zoom!: number;

  private oldValue: number | string = 0;
  private realZoom: number = window.innerWidth >= 320 && window.innerWidth <= 820 ? this.zoom : 1;

  private get intValue() {
    if (typeof this.value === 'string') {
      return parseFloat(this.value);
    }

    return this.value;
  }

  private get numberOfValues() {
    return (this.maxValue - this.minValue) / this.steep;
  }

  private get pointerLeft() {
    if ((0 === this.intValue && 'right' === this.pullDirection) || this.intValue >= this.maxValue) {
      return '100%';
    }

    return ((this.intValue - this.minValue) * 100) / (this.numberOfValues * this.steep) + '%';
  }

  private get pullDirection(): string {
    return (this.intValue !== 0 && this.intValue - <number> this.oldValue > 0)
      ? 'right' : 'left';
  }

  @Watch('value')
  private onValueChanged(value: number | string, oldValue: number | string) {
    this.oldValue = oldValue;
  }

  private handleMouseDown(e: any) {
    this.handleChange(e, true);
    window.addEventListener('mousemove', this.handleChangeWithPrevent);
    window.addEventListener('mouseup', this.handleMouseUp);
  }

  private unbindEventListeners() {
    window.removeEventListener('mousemove', this.handleChangeWithPrevent);
    window.removeEventListener('mouseup', this.handleMouseUp);
  }

  private handleChangeWithPrevent(e: any) {
    this.handleChange(e, false);
  }

  private handleChange(e: any, skip: boolean) {
    !skip && e.preventDefault();

    const container: HTMLElement = <HTMLElement> this.$refs.container;
    const containerWidth = container.clientWidth * this.realZoom;
    const xOffset = container.getBoundingClientRect().left * this.realZoom + window.scrollX;
    const pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
    const left = pageX - xOffset;
    const percent = left * 100 / containerWidth;
    const h = this.numberOfValues * percent * this.steep / 100 + this.minValue;

    let value = parseFloat((Math.round(h / this.steep) * this.steep).toFixed(2));

    if (value < this.minValue) {
      value = this.minValue;
    } else if (value > this.maxValue) {
      value = this.maxValue;
    }

    if (this.intValue !== value) {
      this.$emit('input', value);
    }
  }

  private handleMouseUp() {
    this.unbindEventListeners();
  }
}
